'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PASSWORD_RESET_REQUESTED = exports.PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED';
var PASSWORD_RESET_REQUEST_FAILED = exports.PASSWORD_RESET_REQUEST_FAILED = 'PASSWORD_RESET_REQUEST_FAILED';


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/forgottenPassword/forgottenPasswordConstants.js
// module id = 671
// module chunks = 0